exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content{padding:75px 15px;margin-left:225px;transform:translateZ(0)}.con-main{position:relative}@media screen and (min-width:980px){.con-main{width:980px;max-width:100%}}@media screen and (min-width:1180px){.con-main{width:100%}}@media screen and (max-width:799px){.content{margin-left:0;padding-top:50px}.con-main{max-width:100%}}.breadcrumb{position:absolute;text-align:right;background-color:transparent;padding-top:12px}.view{margin-top:-2px;padding-top:8px}.change{width:98%}.zz{width:78%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3355933f!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Appmain.vue
// module id = 579
// module chunks = 2